import { Layout, Container } from 'ui/components';
import type { WidgetWrapperProps } from './WidgetWrapper.d';

const WidgetWrapper = ({ children, ...layout }: WidgetWrapperProps) => {
  if (!Object.keys(layout).length) {
    return children;
  }

  const {
    alternateColor = false,
    componentFluidMobile,
    containerHorizontalAlignment,
    containerVerticalAlignment,
    containerWidth = 'default',
    fluid,
    fluidMobile,
    marginBottom = 'sp-0',
    marginTop = 'sp-0',
  } = layout;

  const containerSize = fluid ? 'full' : containerWidth;

  return (
    <Layout
      alternateColor={alternateColor}
      horizontalAlign={containerHorizontalAlignment}
      verticalAlign={containerVerticalAlignment}
    >
      <Container
        fluid={componentFluidMobile || fluidMobile}
        marginBottom={marginBottom}
        marginTop={marginTop}
        size={containerSize}
      >
        {children}
      </Container>
    </Layout>
  );
};

export default WidgetWrapper;
